import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { IAttachmentDocument } from '@shared/interfaces';

import { FilesService } from '../../../../services/files.service';

@Component({
  selector: 'app-image-popup',
  templateUrl: './image-popup.component.html',
  styleUrls: ['./image-popup.component.scss'],
  encapsulation: ViewEncapsulation.None, // Disable encapsulation for global styling
})
export class ImagePopupDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('carousel', { static: false }) carousel: NgbCarousel;
  imageUrls: string[] = [];
  selectedImageIndex = 0;
  activeSlide = 0; // Tracks the current active slide

  constructor(
    public dialogRef: MatDialogRef<ImagePopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { asset_image: IAttachmentDocument[] },
    private paginatorIntl: MatPaginatorIntl,
    public translate: TranslateService,
    private filesService: FilesService
  ) {}

  ngOnInit(): void {
    this.loadImages();
  }

  ngAfterViewInit(): void {
    if (this.carousel) {
      this.carousel.select(this.selectedImageIndex.toString());
    }
  }

  private async loadImages(): Promise<void> {
    const imagePromises = this.data.asset_image.map(async (document) => {
      const url = await this.filesService
        .getDMSFilePreviewUrlListener(document.file_id)
        .toPromise();
      return url ? url : null;
    });

    this.imageUrls = (await Promise.all(imagePromises)).filter(
      (url) => url !== null
    ) as string[];
  }

  onThumbnailClick(index: number): void {
    this.selectedImageIndex = index;
    this.onSlide(this.carousel);
    if (this.carousel) {
      this.carousel.select(index.toString());
    }
  }

  onSlide(event: any): void {
    this.activeSlide = parseInt(event.current, 10); // Convert slide ID back to number
  }

  onClose(): void {
    this.imageUrls.forEach((url) => URL.revokeObjectURL(url));
    this.dialogRef.close();
  }
}
